export default {
    customPopupSyles: {
        padding: "0px 60px 30px 40px"
    },
    bodyContent: {
        display: "flex",
        flexDirection: "column",
        rowGap: "20px"
    },
    buttonsContainer: {
        display: "flex",
        alignItems: "center",
        columnGap: "20px"
    }
}